import React from 'react';
import { Field } from 'formik';
import CustomInputTextComponent from 'components/Form/CustomInputTextComponent';
import Select from 'components/Form/Select';

const GeneralForm = ({ labParamGroups }) => (
	<div>
		<Field
			type='text'
			name='name'
			customlabel='Nom du laboratoire'
			component={CustomInputTextComponent}
			required
		/>
		<Field
			type='text'
			name='ip_range'
			customlabel='Plage IP'
			component={CustomInputTextComponent}
		/>
		<Field
			type='text'
			name='folder_num_format'
			customlabel='Format'
			component={CustomInputTextComponent}
		/>
		<Field
			component={Select}
			name='labParamGroup.id'
			customlabel='Groupe de paramétrage laboratoire'
			placeholder='Sélectionner un groupe'
			options={labParamGroups.list.data.map(group => {
				return {
					value: group.id,
					label: group.name
				};
			})}
			required
		/>
	</div>
);

export default GeneralForm;
